import { connect } from 'react-redux';
import GroupDirShDashboard from '../components/GroupDirShDashboard';

import {
    queryGroupDirSh,
    initQueryGroupDirShActionStatus,
    groupDirShQueryChangeInput,
    selectGroupDirSh,
    openAddOrEditGroupDirShModal,
    resetAddOrEditGroupDirShModal,
    addOrEditGroupDirShChangeInput,
    submitAddGroupDirSh,
    initSubmitAddGroupDirShActionStatus,
    submitUpdateGroupDirSh,
    initSubmitUpdateGroupDirShActionStatus,
    openDelGroupDirShModal,
    resetDelGroupDirShModal,
    submitDelGroupDirSh,
    initSubmitDelGroupDirShActionStatus,
} from '../GroupDirShActions';
import { loadCountryCodes } from '../../../home/homeActions';

import { doOperationRecordAction } from '../../../common/operationRcd/OperationRecordActions';

const mapStateToProps = state => {
    return {
        countryCodeDOArray: state.home.countryCodeDOArray,
        queryFields: state.groupDirSh.queryFields,
        queryGroupDirShStatus: state.groupDirSh.queryGroupDirShStatus,
        queryGroupDirShResp: state.groupDirSh.queryGroupDirShResp,
        selectedGroupDirShArray: state.groupDirSh.selectedGroupDirShArray,
        groupDirShModal: state.groupDirSh.groupDirShModal,
        submitAddGroupDirShStatus: state.groupDirSh.submitAddGroupDirShStatus,
        submitUpdateGroupDirShStatus: state.groupDirSh.submitUpdateGroupDirShStatus,
        delGroupDirShModal: state.groupDirSh.delGroupDirShModal,
        submitDelGroupDirShStatus: state.groupDirSh.submitDelGroupDirShStatus,
        operationRecord: state.operationRecord,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadCountryCodes: () => dispatch(loadCountryCodes()),
        queryGroupDirSh: () => dispatch(queryGroupDirSh()),
        initQueryGroupDirShActionStatus: () => dispatch(initQueryGroupDirShActionStatus()),
        groupDirShQueryChangeInput: input => dispatch(groupDirShQueryChangeInput(input)),
        selectGroupDirSh: array => dispatch(selectGroupDirSh(array)),
        openAddOrEditGroupDirShModal: (mode, data) => dispatch(openAddOrEditGroupDirShModal(mode, data)),
        resetAddOrEditGroupDirShModal: () => dispatch(resetAddOrEditGroupDirShModal()),
        addOrEditGroupDirShChangeInput: input => dispatch(addOrEditGroupDirShChangeInput(input)),
        submitAddGroupDirSh: data => dispatch(submitAddGroupDirSh(data)),
        initSubmitAddGroupDirShActionStatus: () => dispatch(initSubmitAddGroupDirShActionStatus()),
        submitUpdateGroupDirSh: data => dispatch(submitUpdateGroupDirSh(data)),
        initSubmitUpdateGroupDirShActionStatus: () => dispatch(initSubmitUpdateGroupDirShActionStatus()),
        openDelGroupDirShModal: data => dispatch(openDelGroupDirShModal(data)),
        resetDelGroupDirShModal: () => dispatch(resetDelGroupDirShModal()),
        submitDelGroupDirSh: data => dispatch(submitDelGroupDirSh(data)),
        initSubmitDelGroupDirShActionStatus: () => dispatch(initSubmitDelGroupDirShActionStatus()),
        doOperationRecordAction: params => dispatch(doOperationRecordAction(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupDirShDashboard);
